import {toPropertyName} from '../utils';

export default function camelCaseProperties(state) {
	for (const k in state.properties) {
		const newKey = toPropertyName(k);
		if (newKey !== k) {
			state.properties[newKey] = state.properties[k];
			delete state.properties[k];
		}
	}
	return state;
}
